import PageContainer from 'components/common/PageContainer/PageContainer';
import SettingHeader from 'components/Settings/Components/SettingHeader/settingHeader';
import { settingsConfig } from 'components/Settings/settingsConfig';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { TagsEdit } from 'components/Settings/Components/Tags/components/tagsEdit';

export const TagsEditPage = () => {
    useFullStoryPageView({ pageName: settingsConfig.tagsEdit.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <SettingHeader title={settingsConfig.tagsEdit.title} subTitle={'Add & edit Tags'} isBackArrow={true} />
            </HeaderWrapper>
            <MainContent>
                <TagsEdit />
            </MainContent>
        </PageContainer>
    );
};
